
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/musicprogram",
      function () {
        return require("private-next-pages/musicprogram.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/musicprogram"])
      });
    }
  